import React from 'react';
import { FolderEdit, UserPlus } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

export const MergePipelineDialog = ({ open, onOpenChange, selectedRowsData, onMerge }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Merge Pipeline Lines</AlertDialogTitle>
        <AlertDialogDescription>
          {(() => {
            const newDealRow = selectedRowsData.find(r => r.pipeline === 'NEW DEAL');
            const targetRow = selectedRowsData.find(r => r.pipeline === 'CROSS SELLING' || r.pipeline === 'UP SELLING');
            return (
              <>
                This will merge the selected lines:
                <br /><br />
                <strong className="text-red-600">DELETE:</strong> {newDealRow?.pipeline} - {newDealRow?.productGroup || 'No Group'} {newDealRow?.productName ? `(${newDealRow.productName})` : ''}
                <br />
                <strong className="text-green-600">KEEP:</strong> {targetRow?.pipeline} - {targetRow?.productGroup || 'No Group'} {targetRow?.productName ? `(${targetRow.productName})` : ''}
                <br /><br />
                The NEW DEAL row will be <strong className="text-red-600">permanently removed</strong>.
              </>
            );
          })()}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onMerge} className="bg-red-600 hover:bg-red-700">
          Confirm Merge
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const DivisionChangeDialog = ({ open, onOpenChange, customer, divisions, newDivision, setNewDivision, onUpdate }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Change Division</DialogTitle>
        <DialogDescription>
          Update division for {customer?.name}. Current: {customer?.division || 'None'}
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <Select value={newDivision} onValueChange={setNewDivision}>
          <SelectTrigger>
            <SelectValue placeholder="Select division" />
          </SelectTrigger>
          <SelectContent>
            {divisions.map(d => (
              <SelectItem key={d} value={d}>{d}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onUpdate} disabled={!newDivision} className="bg-orange-600 hover:bg-orange-700">
          <FolderEdit className="h-4 w-4 mr-2" />
          Update Division
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const TransferDialog = ({ open, onOpenChange, customer, managers, transferManagerId, setTransferManagerId, onTransfer }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Transfer Customer</DialogTitle>
        <DialogDescription>
          Transfer {customer?.name} to a different account manager.
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <Select value={transferManagerId} onValueChange={setTransferManagerId}>
          <SelectTrigger>
            <SelectValue placeholder="Select account manager" />
          </SelectTrigger>
          <SelectContent>
            {managers.map(m => (
              <SelectItem key={m.emp_id || m.id} value={m.emp_id || m.id}>{m.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onTransfer} disabled={!transferManagerId} className="bg-blue-600 hover:bg-blue-700">
          <UserPlus className="h-4 w-4 mr-2" />
          Transfer
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
